import React, { Component } from 'react';
//import {Button} from 'mdbreact';
import { withRouter } from 'react-router-dom';
import {Link} from 'react-router-dom'
import './css/home.css';

import icona from './img/busy.png'




class App extends Component {

render(){
return(<div>

<div class=" pt-md-4" id="backgroundH">

<div class="row">
    <div class="col-md-6 pl-md-5 pt-2 pt-md-5" >

<h1 id="titule"  >
<center> 
  <div > Brenda Morales</div>
 
  </center> 
 
  </h1>
  <h2  id="titulee" >
  <center> 
   Front-End Developer
   </center> 
   <div class="contact pt-3 pt-md-4">
   <center> 

<a target='_blank' rel = "noopener noreferrer" href="https://github.com/brenduchiz?tab=repositories" >
<i  class="fab fa-github pl-4 pl-md-4 pr-4 pr-md-4"></i> 
 </a>

  <a target='_blank' rel = "noopener noreferrer"href="mailto:brendamorpe@gmail.com" >
 <i class="far fa-envelope pr-4 pr-md-4"></i>
 </a>
 

 <a target='_blank' rel = "noopener noreferrer" href="https://www.linkedin.com/in/brenda-mora/" >
 <i class="fab fa-linkedin pr-4 pr-md-4"></i>
 </a>

 </center> 
   </div>
   
   </h2>
  <center> 

    <Link class="btn btn-outline-yellow accent-2 waves-effect mt-4 mb-2 "  to='/about'>
    Conóceme
</Link>
  
  </center>

    
    </div>
    
    <div class="col-md-6 pr-md-5 pt-4"  id="img"  >
    <center> 
    <img src={icona} alt="logo"  />
    
    </center> 
   
  
    
    
    </div>
    
   
  </div>



</div>
</div>);
}
}
export default withRouter(App);